import { createSlice } from '@reduxjs/toolkit'

export const SIPReducer = createSlice({
    name: 'sip',
    initialState: {
        sipProfileList: []
    },
    reducers: {
        setSIPProfileList: (state, action) => {
            state.sipProfileList = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setSIPProfileList } = SIPReducer.actions

export default SIPReducer.reducer